export default __webpack_public_path__ + "static/media/import-icon.bdf702ec.svg";